import { render, staticRenderFns } from "./SystemMessageTip.vue?vue&type=template&id=6b0dce67&scoped=true&"
import script from "./SystemMessageTip.vue?vue&type=script&lang=ts&"
export * from "./SystemMessageTip.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessageTip.vue?vue&type=style&index=0&id=6b0dce67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0dce67",
  null
  
)

export default component.exports